import {
  GridFilterModel,
  GridSortModel
} from "@mui/x-data-grid";
import { create } from "zustand";

type StoryConfigsDatagridState = {
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
};

type StoryConfigsDatagridActions = {
  setSortModel: (model: GridSortModel) => void;
  setFilterModel: (model: GridFilterModel) => void;
};

export const useStoryConfigsDatagridStore = create<
  StoryConfigsDatagridState & StoryConfigsDatagridActions
>((set) => ({
  sortModel: [],
  filterModel: { items: [] },
  setSortModel: (model) => set({ sortModel: model }),
  setFilterModel: (model) => set({ filterModel: model }),
}));
